import { type FC, type ReactNode } from "react";

import { Button } from "@/shared/components/ui/button";
import { Separator } from "@/shared/components/ui/separator";

interface EditSectionShellProps {
  title: string;
  onCancel: () => void;
  onSave: () => void;
  isSaving: boolean;
  children: ReactNode;
}

export const EditSectionShell: FC<EditSectionShellProps> = ({
  title,
  onCancel,
  onSave,
  isSaving,
  children,
}) => (
  <div className="border border-primary rounded-lg">
    <div className="flex items-center p-4">
      <p className="flex-1 text-base font-semibold">{title}</p>
    </div>
    <Separator />
    <div className="flex flex-col gap-6 p-4">{children}</div>
    <div className="flex items-center justify-end gap-3 p-4">
      <Button variant="outline" onClick={onCancel} disabled={isSaving}>
        Cancel
      </Button>
      <Button variant="brand" onClick={onSave} disabled={isSaving}>
        {isSaving ? "Saving..." : "Save changes"}
      </Button>
    </div>
  </div>
);
